module.exports = __webpack_public_path__ + "assets/img/business-ecology-icon2-new.60710a45.png";